// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xIsAuthenticated } from "@adl/XDL/Utilities/helpers";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import Zone from "@insite/client-framework/Components/Zone";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import React, { useEffect } from "react";

type Props = PageProps;

export interface ReorderPadPageStyles {
    page?: MobiusPageProps;
}

export const reorderPadPageStyles: ReorderPadPageStyles = {};

const styles = reorderPadPageStyles;

const ReorderPadPage = ({ id }: Props) => {
    const history = useHistory();
    const { signInUrl, currentLocation, isAuthenticated } = useAppSelector(state => ({
        signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        currentLocation: getLocation(state),
        isAuthenticated: xIsAuthenticated(state),
    }));

    useEffect(() => {
        if (isAuthenticated || !signInUrl) {
            return;
        }
        const returnUrl = currentLocation.pathname + currentLocation.search;
        if (returnUrl === "/") {
            history.push(`${signInUrl}`);
        } else {
            history.push(`${signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}&clientRedirect=true`);
        }
    }, [signInUrl]);

    if (!isAuthenticated) {
        return null;
    }
    return (
        <Page data-test-selector="ReorderPadPage" {...styles.page}>
            <Zone contentId={id} zoneName="Content" />
            <Modals />
        </Page>
    );
};

const pageModule: PageModule = {
    component: ReorderPadPage,
    definition: {
        displayName: "Reorder Pad",
        hasEditableTitle: true,
        hasEditableUrlSegment: false,
        pageType: "System",
    },
};

export default pageModule;
